import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SewTableHeaderFilter, SewTableHeaderSort } from '@sew/ui-components-angular/standalone';
import { from, merge } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { TableFilterService } from '../../../services/table-filter/table-filter.service';
import { SortOrder } from '../../../services/table-sort/table-sort.interface';
import { TableSortService } from '../../../services/table-sort/table-sort.service';
import { FilterTableHeaderComponent } from '../filter-table-header.component';

@Component({
    selector: 'osc-text-filter-table-header',
    templateUrl: './text-filter-table-header.component.html',
    styleUrls: ['./text-filter-table-header.component.scss'],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        AsyncPipe,
        TranslatePipe,
        SewTableHeaderFilter,
        SewTableHeaderSort,
    ],
})
export class TextFilterTableHeaderComponent<T, G, E>
    extends FilterTableHeaderComponent<T, G, E>
    implements OnInit, OnChanges
{
    @Input() public name?: string;
    @Input() public ellipsis?: boolean = false;
    @Input() public filterProperty?: keyof T & string;
    @Input() public tagPosition?: number;
    @Input() public set sortOrder(sortOrder: SortOrder) {
        this.sortOrderInput.next(sortOrder);
        this.order = sortOrder;
    }

    @Input() public showFilterInput = true;
    @Input() public hideSortIconOnClosedState = false;

    public constructor(
        public filterService: TableFilterService<T, G, E>,
        public sortService: TableSortService<T, G, E>,
        private changeDectRef: ChangeDetectorRef
    ) {
        super(filterService, sortService);
    }

    public ngOnInit(): void {
        if (!this.filterProperty) {
            return console.warn('Trying to initialize a text filter without filterProperty');
        }

        if (this.showFilterInput) {
            this.filterValue = this.filterService.watchPropertyValue(this.filterProperty).pipe(
                // WORKAROUND needed because ngmodel sometimes doesn't detect change on itself
                switchMap((value) => from([null as any, value])),
                tap(() => {
                    this.changeDectRef.detectChanges();
                })
            );
        }

        this.sortOrderObs = merge(
            this.sortOrderInput,
            this.sortService.watchPropertyValue(this.filterProperty)
        );
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.filterProperty || changes.sortOrder) {
            if (this.filterProperty && this.order) {
                this.sortService.inititizeSorting = () => {
                    if (this.order) {
                        this.updateSorting(this.order);
                    }
                };
            }
        }
    }
}
